import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'

const Wrapper = styled.div`
  position: relative;
  display = block;
  padding-left: 10px;
  padding-right: 10px;
  width: 25%;
  float: left;
`

const Input = styled.input`
  border: none;
  outline: none;
  color: ${props => {
    if (props.error) {
      return '#fa6060'
    } else if (props.disabled) {
      return '#7fb940'
    }
    return 'transparent'
  }};
  text-shadow: 0 0 0 black;
  text-align: center;
  border-radius: 0;
  border-bottom-color: #000;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  width: 100%;
  font-size: 60px;
  font-weight: bold;
  padding: 0 5px 0 5px;

  :focus {
    border-bottom-color: #7fb940;
  }
`

class DigitInput extends Component {
  state = { inputValue: NaN }

  getInputValue = () => this.state.inputValue

  handleKeyDown = e => {
    e.preventDefault()
    const key = e.which || e.keyCode || e.charCode
    if ((key >= 48 && key <= 57) || (key >= 96 && key <= 105)) {
      // 0 - 9
      let digit = null
      if (key >= 96) {
        digit = key - 96
      } else {
        digit = key - 48
      }
      this.setState({ inputValue: digit })
      this.props.onDigitInput(
        digit,
        this.props.digitInputIndex,
        this.getInputValue
      )
    } else if (key === 8 || key === 46) {
      // delete or backspace
      this.setState({ inputValue: NaN })
      this.props.onDigitInput(
        'DEL',
        this.props.digitInputIndex,
        this.getInputValue
      )
    }
  }

  handleChange = e => {
    // e.which || e.keyCode || e.charCode in handleKeyDown() is always 229 i Chrome for Android, this is a fallback for that.
    const digit = e.target.value
    if (digit >= 0 && digit <= 9) {
      this.setState({ inputValue: digit })

      this.props.onDigitInput(
        digit,
        this.props.digitInputIndex,
        this.getInputValue
      )
    } else {
      const digits = Array.from(digit.toString()).map(Number)
      // change current value with new value
      this.setState({
        inputValue: digits[0] === this.state.inputValue ? digits[1] : digits[0],
      })
    }
  }

  render() {
    return (
      <div>
        <Wrapper>
          <Input
            type={'number'}
            pattern={'[0-9]*'}
            onKeyDown={this.handleKeyDown}
            onChange={this.handleChange}
            value={this.state.inputValue}
            autoFocus={this.props.autoFocus}
            ref={this.props.digitInputRef}
            disabled={
              this.props.disabled && !this.props.error ? 'disabled' : ''
            }
            error={this.props.error}
          />
        </Wrapper>
      </div>
    )
  }
}

DigitInput.propTypes = {
  autoFocus: PropTypes.bool,
  digitInputRef: PropTypes.func.isRequired,
  onDigitInput: PropTypes.func.isRequired,
  digitInputIndex: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
}

DigitInput.defaultProps = {
  autoFocus: false,
  digitInputIndex: 0,
}

export default DigitInput
